import _ from 'underscore';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { withPermissions } from '@bingads-webui-react/hoc-with-permissions';
import { isNavigationRefreshOn } from '@bingads-webui-react/preference-utility';
import DynamicItem from './DynamicItem';
import { getMenuItemListStyles } from '../styles/main-menu-styles';

class DynamicItemList extends React.PureComponent {
  render() {
    const {
      classes,
      items,
      onMenuItemClick,
      isExpanded,
      i18n,
      permissions,
    } = this.props;

    const isNavRefresh = isNavigationRefreshOn(permissions);
    const cnames = classNames(['main-menu-link-list',
      classes.menuList,
      isNavRefresh ? null : classes.menuListBorder,
      'dynamatic-item-list']);

    return (
      <div className={cnames} style={{ marginTop: '0px' }}>
        {isExpanded && items.length > 0 &&
          <div>
            <div className={classNames(classes.recentReportsLabel, isNavRefresh ? '' : classes.recentReportLightLabel)}>
              {i18n.getString(_TL_('Recent reports'))}
            </div>
            {items.map(report =>
            (
              <DynamicItem
                // Default reports have Id === 0, so append ReportType to make sure key is unique
                key={`${report.Id}-${report.ReportType}`}
                node={report}
                isExpanded={isExpanded}
                renderText={isExpanded ? report.Name : null}
                onItemClick={onMenuItemClick}
                isRunning={report.State === 'InProgress'}
              />
            ))}
          </div>
        }
      </div>
    );
  }
}

DynamicItemList.propTypes = {
  classes: PropTypes.shape(_.mapObject(
    getMenuItemListStyles(),
    _.constant(PropTypes.string.isRequired)
  )).isRequired,
  isExpanded: PropTypes.bool.isRequired,
  items: PropTypes.arrayOf(PropTypes.shape({
    Id: PropTypes.number.isRequired,
    Name: PropTypes.string.isRequired,
    State: PropTypes.string.isRequired,
  })),
  onMenuItemClick: PropTypes.func,
  i18n: PropTypes.shape({}).isRequired,
  permissions: PropTypes.shape({
    dynamic: PropTypes.shape({
      NavigationRefresh: PropTypes.bool,
    }),
  }).isRequired,
};

DynamicItemList.defaultProps = {
  items: [],
  onMenuItemClick: () => { },
};

export const StyledDynamicItemList = withPermissions(withDefaultStyles(DynamicItemList, getMenuItemListStyles));
